import type { Me } from '@cocoonspace/sdk-js/types/me'

type DisplayNameParams = Pick<Me, 'first_name' | 'last_name' | 'email'> & {
	defaultValue?: string
}

export const getDisplayName = ({
	first_name,
	last_name,
	email,
	defaultValue = '',
}: DisplayNameParams) => {
	if (!first_name && !last_name && !email) return defaultValue

	return first_name && last_name ? `${first_name} ${last_name}` : email
}
